import { SxProps, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SurveyModalStyles = styled('div')`
    display: flex;
    justify-content: center;
`;

export const SubtitleWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Label = styled('div')(
    ({ theme }) => `
    display: flex;
    align-items: center;
    gap: 6px;
    color: ${theme.palette.primary.main};
    cursor: pointer;
`,
);

export const HeaderStyles = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const RatingStyles = styled('div')`
    display: flex;
    justify-content: center;
`;

export const TextFieldStyles: SxProps<Theme> = (theme) => ({
    border: `1px solid ${theme.palette.grey[500]}`,
    width: '95%',
    borderRadius: '10px',
    padding: '10px 0 10px 10px',
    margin: '10px 0 10px 0',
});

export const ActionStyles: SxProps = {
    padding: '10px 0 0 0',
};

export const ContentStyles: SxProps<Theme> = (theme) => ({
    typography: {
        color: theme.palette.grey[900],
    },
});
